import { useState, useEffect, useCallback } from 'react';
import { movies as allMovies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

const hotMovies = allMovies.filter((m) => m.isHot).slice(0, 3);

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % hotMovies.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + hotMovies.length) % hotMovies.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const movie = hotMovies[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={movie.image}
          alt={`${movie.title} - 丫丫影院免费在线观看`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 w-full mx-auto">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            丫丫影院
          </h1>
          <p className="text-sm md:text-lg text-background-50/80 mb-8 leading-relaxed max-w-xl mx-auto">
            免费电视剧全集电影大全，无需付费注册，全集免费看，高清不缓冲在线观看，最新免费影视资源
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 justify-center">
            <a
              href="/category/tv"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              立即观看
            </a>
            <a
              href="/category/movie"
              className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 text-background-50 px-6 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              <i className="ri-film-line text-lg"></i>
              热门电影
            </a>
          </div>
        </div>

        <div className="absolute bottom-8 md:bottom-12 left-0 right-0 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-3 gap-3 md:gap-4">
              {hotMovies.map((m, idx) => (
                <div
                  key={m.id}
                  onClick={() => setCurrent(idx)}
                  className={`relative rounded-lg overflow-hidden h-20 md:h-28 cursor-pointer border-2 transition-all ${
                    idx === current
                      ? 'border-primary-500 scale-105'
                      : 'border-transparent opacity-70 hover:opacity-100'
                  }`}
                >
                  <img
                    src={m.image}
                    alt={m.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                    <span className="text-xs md:text-sm text-background-50 font-medium truncate px-1">
                      {m.title}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-10 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/30 text-background-50 backdrop-blur-sm transition-all cursor-pointer"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-10 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 hover:bg-background-50/30 text-background-50 backdrop-blur-sm transition-all cursor-pointer"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>
    </section>
  );
}